import { useAppSelector } from "@/app_redux/hooks/root_hook";
import { ModalReducerStateIdKeys } from "@/app_redux/reducers/reducer_interface";

export const useModalState = (modalId: ModalReducerStateIdKeys) => {
  const modalStates = useAppSelector((state) => state.modal_states);
  return modalStates[modalId] ?? {};
};
